<article class="vr-content-card">
  <div class="vr-content-card__media">
    <img [lazyLoad]="content().image" [alt]="content().title + ' en ' + content().municipality" />
    <span class="vr-content-card__shade" aria-hidden="true"></span>
    <span class="vr-content-card__type">
      <i
        [class]="content().type === 'tour-360' ? 'inm-icon-vr-glasses' : 'fa-solid fa-play'"
        aria-hidden="true"
      ></i>
      {{ typeLabel() }}
    </span>
    <span class="vr-content-card__rating">
      <i class="fa-solid fa-star" aria-hidden="true"></i>
      <strong>{{ content().rating }}</strong>
      <small>{{ content().reviews }} reseñas</small>
    </span>
    <span class="vr-content-card__badge">360°</span>
  </div>

  <div class="vr-content-card__content">
    <p class="vr-content-card__location">
      <i class="fa-solid fa-location-dot" aria-hidden="true"></i>
      {{ content().municipality }}, {{ content().department }}
    </p>
    <h3>{{ content().title }}</h3>
    <p class="vr-content-card__description">{{ content().description }}</p>
    <div class="vr-content-card__footer">
      <span
        ><i class="fa-regular fa-clock" aria-hidden="true"></i
        >{{ content().durationMinutes }} min</span
      >
      <button type="button" (click)="open.emit(content())">
        Vivir experiencia
        <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</article>
